import { commonComponents as cc } from "@/components/common";
import { schedulesQueryOptions } from "@/features/schedules/api/selectSchedules";
import { timeComponents as tc } from "@/features/schedules/components";
import { createFileRoute } from "@tanstack/react-router";
import { ui } from "../../../components/ui";

const Schedules = () => {
	const { schedules } = Route.useLoaderData();
	return (
		<section className="my-8">
			<cc.Title words="Schedules" />
			<div className="gap-4 grid md:grid-cols-2 lg:grid-cols-3 col-span-1 mx-auto max-w-lg">
				{schedules?.map((t) => (
					<ui.Card className="p-4 w-full" key={t.schedule_id}>
						<tc.SchedulePreview schedule={t} />
					</ui.Card>
				))}
			</div>
		</section>
	);
};

export const Route = createFileRoute("/_app/schedules/")({
	component: Schedules,
	loader: async ({ context }) => {
		const schedules = await context?.queryClient.ensureQueryData(
			schedulesQueryOptions(),
		);
		return { schedules };
	},
});
